import { render, staticRenderFns } from "./DialogAutoMountPoint.vue?vue&type=template&id=32715643&"
import script from "./DialogAutoMountPoint.vue?vue&type=script&lang=js&"
export * from "./DialogAutoMountPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports